import Styled from "styled-components";

export type CardVariant = "light" | "dark";

export interface CardContainerProps {
  $variant: CardVariant;
}

export interface IconImageContainerProps {
  $variant: CardVariant;
}

export const Container = Styled.div`
  padding: 4rem 0;
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Title = Styled.div`
  font-size: 1.875rem;
  font-weight: 600;
  line-height: 2.25rem;
  letter-spacing: -0.3px;
  text-align: center;
`;

export const CardsContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex-flow: row;
    flex-wrap: wrap;
    align-items: stretch;
  }
`;

export const Card = Styled.div<CardContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2rem;
  color: #030303;
  background-color: #FAFAFA;
  border-radius: 1.25rem;
  padding: 1.875rem;

  ${(props) =>
    props.$variant === "dark" &&
    `
    color: #FAFAFA;
    background-color: #000;
  `};

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex: 1 1 17rem;
    justify-content: flex-start;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    flex: 1 1 25rem;
    padding: 4.625rem;
  }

  * {
    color: inherit !important;
  }
`;

export const IconImageContainer = Styled.div<IconImageContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 1rem;
  background-color: #E7E7E7;
  margin-bottom: .5rem;

  & > img {
    width: 1.562rem;
    height: 1.562rem;
  }

  ${(props) =>
    props.$variant === "dark" &&
    `
    background-color: #232323;
  `};
`;

export const Description = Styled.div`
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.2px;

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 1rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.624rem;
    line-height: 2rem;
  }

`;

export const Link = Styled.a`
  text-decoration: none;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("large")} {
    width: auto;
  }
`;
